import { params, string, json } from '@thd-nucleus/data-sources';

export const emtContentDataModel = {
  emtContent: params({
    contentId: string().isRequired(),
    pageName: string().isRequired()
  }).shape({
    content: json()
  })
};